import styled from "styled-components";

import { NotificationContainerWrapper } from "shared/components/organisms/AppNotification/components/atoms/NotificationContainer/styles";

export const PrivateNotificationContainer = styled.div`
  ${NotificationContainerWrapper} {
    background: ${({ theme }) =>
      theme.notification.privateNotification.background} !important;

    border-left: 2px solid
      ${({ theme }) => theme.notification.privateNotification.borderLeft} !important;
  }
`;
